module.exports = __webpack_public_path__ + "img/3-4.53d886ea.png";